import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import Header from './components/Header';
import PokemonList from './components/PokemonList';
import Details from './components/Details'
import { PokemonProvider } from './Context/PokemonContext';
import MissingNoCard from './components/MissingNoCard';


const router = createBrowserRouter([
  {
    path: "/",
    element: <div
    className="App overflow-hidden mx-auto bg-primary p-[4px] flex-col w-[360px]
      flex ">
      <Header/>
      <PokemonList/>
    </div>,
  },
  {
    path:'/:pokemonName',
    element: <div className='App mx-auto overflow-hidden flex-col w-[360px]
      flex '>
      <Details/>
    </div>
  }, {
    path:'/*',
    element: <div className='App mx-auto overflow-hidden flex-col w-[360px]
      flex '>
        <MissingNoCard/>
    </div>
  }

]);



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PokemonProvider>
      <RouterProvider router={router} />
    </PokemonProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
